// AppContext.jsx
// @ts-nocheck
import React, { createContext, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const AppContext = createContext({
  filters: {
    areaOfExpertise: [],
    geoOptions: "",
    yearsOfExperience: "",
    cost: "",
    role: "",
  },
  setFilters: (newFilters) => {},
  profiles: [],
  setProfiles: (newProfiles) => {},
  currentTimeUTC: "",
  navigate: (path, options) => {},
  goBack: () => {},
});

export const AppProvider = ({ children }) => {
  const [filters, setFilters] = useState({
    areaOfExpertise: [],
    geoOptions: "",
    yearsOfExperience: "",
    cost: "",
    role: "",
  });
  const [profiles, setProfiles] = useState([]);
  const currentTimeUTC = dayjs().utc().format();
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  const value = {
    filters,
    setFilters,
    profiles,
    setProfiles,
    currentTimeUTC,
    navigate,
    goBack,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useAppContext = () => useContext(AppContext);
